<template>
  <div :class="$style.frameParent">
    <div :class="$style.frameParent3">
      <div :class="$style.frameParent8">
        <div :class="$style.studentOfTheMonthWrapper">
          <b :class="$style.student">Quote of the day</b>
        </div>
        <div :class="$style.mondayApril15th2024Parent">
          <div :class="$style.mondayApril15th">{{ currentFormattedDate }}</div>
          <i :class="$style.knowledgeIsThe"
            >“Knowledge is the eye of desire and can become the pilot of the
            soul.”</i
          >
          <div :class="$style.parent">
            <div :class="$style.currentClass">-</div>
            <div :class="$style.currentClass">Will Durant</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.frameParent13">
      <div :class="$style.frameParent14">
        <div :class="$style.frameWrapper3">
          <div :class="$style.allUpcomingCheckridesWrapper">
            <b :class="$style.student">Upcoming Checkrides</b>
          </div>
        </div>
      </div>
      <div :class="$style.tablesContainer">
        <div :class="$style.tableBorderWrapper">
          <div :class="$style.tableWrapper">
            <table :class="$style.checkridesTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>DPE</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(checkride, index) in firstSet"
                  :key="'first-' + index"
                >
                  <td>{{ checkride.name }}</td>
                  <td>{{ checkride.date }}</td>
                  <td>{{ checkride.dpe }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div :class="$style.tableBorderWrapper">
          <div :class="$style.tableWrapper">
            <table :class="$style.checkridesTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>DPE</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(checkride, index) in secondSet"
                  :key="'second-' + index"
                >
                  <td>{{ checkride.name }}</td>
                  <td>{{ checkride.date }}</td>
                  <td>{{ checkride.dpe }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div :class="$style.tableBorderWrapper">
          <div :class="$style.tableWrapper">
            <table :class="$style.checkridesTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>DPE</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(checkride, index) in thirdSet"
                  :key="'third-' + index"
                >
                  <td>{{ checkride.name }}</td>
                  <td>{{ checkride.date }}</td>
                  <td>{{ checkride.dpe }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CheckridesAPIService from "@/servicehandlers/CheckridesAPIService";
const checkridesAPIService = new CheckridesAPIService();
import { defineComponent } from "vue";
import dayjs from "dayjs";

export default defineComponent({
  data() {
    return {
      scheduledCheckrides: [],
    };
  },
  mounted() {
    this.getCheckrides();
  },
  computed: {
    currentFormattedDate() {
      return dayjs().format("dddd, MMMM D, YYYY");
    },
    firstSet() {
      return this.scheduledCheckrides.slice(
        0,
        Math.ceil(this.scheduledCheckrides.length / 3),
      );
    },
    secondSet() {
      return this.scheduledCheckrides.slice(
        Math.ceil(this.scheduledCheckrides.length / 3),
        Math.ceil((this.scheduledCheckrides.length * 2) / 3),
      );
    },
    thirdSet() {
      return this.scheduledCheckrides.slice(
        Math.ceil((this.scheduledCheckrides.length * 2) / 3),
      );
    },
  },
  methods: {
    getCheckrides() {
      return checkridesAPIService
        .get(this.$router)
        .then((response) => {
          this.scheduledCheckrides = response
            .map((checkride) => {
              checkride.status = checkride.checkrideSchedulingStatus?.name;
              checkride.name =
                `${checkride.activeStudent?.user.firstName} ${checkride.activeStudent?.user.lastName}` ||
                "-";
              checkride.date = checkride.startDateTime;
              checkride.date = checkride.startDateTime
                ? dayjs(checkride.startDateTime).format("MM/DD/YYYY")
                : "-";
              const dpe = checkride.dpe?.user;
              checkride.dpe = dpe ? `${dpe.firstName} ${dpe.lastName}` : "-";
              return checkride;
            })
            .filter((checkride) => checkride.status === "Scheduled");
        })
        .catch(() => {});
    },
  },
});
</script>
<style module scoped>
.tablesContainer {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
}
.tableBorderWrapper {
  flex: 1;
  width: 33%;
  min-width: 450px;
  border-radius: 10px;
  border: 1px solid #929292;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tableWrapper {
  overflow-x: auto;
  width: 100%;
}
.checkridesTable {
  width: 100%;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
}
th,
td {
  padding: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 400 !important;
}
th {
  border-bottom: 1px solid #929292;
  background-color: #696969;
  color: white;
  font-weight: bold;
  box-shadow:
    -1px 0 0 #696969,
    1px 0 0 #696969;
}
th:first-child {
  border-top-left-radius: 10px;
}
th:last-child {
  border-top-right-radius: 10px;
}
td {
  border: 1px solid #929292;
}
.student {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.currentClass {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.studentOfTheMonthWrapper {
  align-self: stretch;
  height: 29px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  box-sizing: border-box;
}
.mondayApril15th {
  position: relative;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.knowledgeIsThe {
  align-self: stretch;
  position: relative;
  font-size: 15px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.parent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 13px;
}
.mondayApril15th2024Parent {
  flex: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 30px;
  gap: 10px;
  color: #000;
  font-family: Inter, Arial, sans-serif;
}
.frameParent8 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
}
.frameParent3 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 30px;
  z-index: 3;
}
.allUpcomingCheckridesWrapper {
  align-self: stretch;
  width: 475px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  box-sizing: border-box;
}
.frameWrapper3 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.frameParent14 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 0;
  gap: 0;
}
.frameParent13 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 15px;
  z-index: 1;
}
.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 25px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
